// トップページ
export function homeFunc() {
  // メインビジュアル動画の設定
  var $mainVisual = $('#mainVisual');
  var $video = $('#mainVisual-video');
  var videoElement = $video[0];
  
  if (videoElement) {
    var videoPc = $mainVisual.data('video-pc') || '';
    var videoSp = $mainVisual.data('video-sp') || '';
    
    // 画面サイズに応じて動画ソースを設定
    function setVideoSource() {
      var windowwidth = window.innerWidth || document.documentElement.clientWidth || 0;
      var videoSrc = windowwidth > 768 ? videoPc : videoSp;
      
      if (videoSrc) {
        if (videoElement.src !== videoSrc) {
          videoElement.src = videoSrc;
          videoElement.load();
        }
        
        // 動画の再生を試みる
        videoElement.play().catch(function(error) {
          console.log('動画の自動再生に失敗しました:', error);
        });
      }
    }
    
    // リサイズ時に動画ソースを切り替え
    var resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setVideoSource, 100);
    });
    
    // 初期設定
    setVideoSource();
  }
  
  // 画像を左から右に表示
  function bgExtend() {
    $('.bgextendTriggar').each(function () {
      var elemPos = $(this).offset().top - 50;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll >= elemPos - windowHeight) {
        $(this).addClass('bgextend , bgappear');
      }
    });
  }
  
  $(window).scroll(function () {
    bgExtend();
  });
  
  $(window).on('load', function () {
    bgExtend();
  });

  // 順番にふわっと表示
  function delayScrollAnime() {
    var time = 0.2;
    var value = time;
    $('.delayScroll').each(function () {
      var parent = this;
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      var childs = $(this).children();
      
      if (scroll >= elemPos - windowHeight && !$(parent).hasClass("play")) {
        $(childs).each(function () {
          if (!$(this).hasClass("fadeUp")) {
            $(parent).addClass("play");
            $(this).css("animation-delay", value + "s");
            $(this).addClass("fadeUp");
            value = value + time;
            var index = $(childs).index(this);
            if ((childs.length - 1) == index) {
              $(parent).removeClass("play");
            }
          }
        });
      }
    });
  }
  
  $(window).scroll(function () {
    delayScrollAnime();
  });
  
  $(window).on('load', function () {
    delayScrollAnime();
  });

  // テキストを下から滑らかに表示
  function SmoothTextAnime() {
    $('.smoothTextTrigger').each(function () {
      var elemPos = $(this).offset().top - 50;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll >= elemPos - windowHeight) {
        $(this).addClass('smoothTextAppear');
      }
    });
  }
  
  $(window).scroll(function () {
    SmoothTextAnime();
  });
  
  $(window).on('load', function () {
    SmoothTextAnime();
  });

  // テキストが光りながら出現
  function GlowAnimeControl() {
    $('.glowAnime').each(function () {
      var elemPos = $(this).offset().top - 50;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll >= elemPos - windowHeight) {
        $(this).addClass("glow");
      }
    });
  }
  
  $(window).scroll(function () {
    GlowAnimeControl();
  });
  
  $(document).ready(function () {
    var element = $(".glowAnime");
    element.each(function () {
      var text = $(this).text();
      var textbox = "";
      text.split('').forEach(function (t, i) {
        if (t !== " ") {
          if (i < 10) {
            textbox += '<span style="animation-delay: .' + i + 's;">' + t + '</span>';
          } else {
            var n = i / 10;
            textbox += '<span style="animation-delay: ' + n + 's;">' + t + '</span>';
          }
        } else {
          textbox += t;
        }
      });
      $(this).html(textbox);
    });
    
    setTimeout(function () {
      GlowAnimeControl();
    }, 2400);
  });

  // スムーススクロール
  $(function () {
    $('a[href^="#"]').click(function () {
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);

      // PCの場合の位置
      var position_pc = target.offset().top - 94;
      // SPの場合の位置
      var position_sp = target.offset().top - 56;

      // 画面サイズによって位置を変更する
      var position = ($(window).width() > 767) ? position_pc : position_sp;

      $('body,html').animate({ scrollTop: position }, 400, 'swing');
      return false;
    });
  });
}
